/* eslint-disable camelcase */

import { ArchiveDeleteResponse } from "components/common/ArchiveDialog/ArchiveDialog";
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { useSwr, axiosInst } from "./axiosWIS";

export interface SubCategory extends Record<string, unknown> {
  id: string;
  sub_cat_name: string;
  sub_cat_desc: string;
  incident_type_count: number;
  pk_sub_cat_id: number;

  created_by: string;
  create_timestamp: string;
  update_by: string;
  update_timestamp: string;

  version: number;
}

const baseKey = "/api/SubCategory";

export const useSubCategories = (
  params?: {
    pageNr?: number;
    pageSize?: number;
    orderBy?: string;
    Order?: string;
    SearchKey?: string;
  },
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<SubCategory>> =>
  useSwr<ApiArrayResponse<SubCategory>>(
    `${baseKey}${
      params?.pageNr && params?.pageSize
        ? `?pageNr=${params?.pageNr}&pageSize=${params?.pageSize}`
        : ""
    }${params?.orderBy != null ? `&orderBy=${params.orderBy}` : ""}${
      params?.Order != null ? `&Order=${params.Order}` : ""
    }${params?.SearchKey ? `&SearchKey=${params.SearchKey}` : ""}`,
    config
  );

export const addSubCategory = async (
  data: Partial<SubCategory>
): Promise<SubCategory> => {
  const res = await axiosInst.post(baseKey, data);
  return res.data;
};

export const editSubCategory = async (data: SubCategory): Promise<unknown> => {
  const res = await axiosInst.put(`${baseKey}/${data.pk_sub_cat_id}`, data);
  return res.data;
};

export const archiveSubCategory = async (
  id: string
): Promise<ArchiveDeleteResponse<number>> => {
  const res = await axiosInst.delete(baseKey, { data: [id] });
  return res.data;
};
